import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { GetAddendumCosignMetaResponse } from "@/core/types/(api)/cosignature";

import { cosignatureKeys } from "../keyFactory";
import { getAddendumCosignMeta } from "../queryFunctions/getAddendumCosignMeta";

type UseAddendumCosignMetaProps<TData = GetAddendumCosignMetaResponse> = {
  documentId: string;
  enabled?: boolean;
  select?: (data: GetAddendumCosignMetaResponse) => TData;
};

type AddendumCosignMetaQueryOptions = UseQueryOptions<
  GetAddendumCosignMetaResponse,
  unknown,
  GetAddendumCosignMetaResponse,
  ReturnType<typeof cosignatureKeys.addendumMeta>
>;

export function optionFactory(documentId: string, enabled = true) {
  return {
    enabled,
    queryFn: () => getAddendumCosignMeta(documentId),
    queryKey: cosignatureKeys.addendumMeta(documentId),
  } satisfies AddendumCosignMetaQueryOptions;
}

export function useAddendumCosignMeta<TData = GetAddendumCosignMetaResponse>({
  documentId,
  enabled,
  select,
}: UseAddendumCosignMetaProps<TData>) {
  return useQuery({ ...optionFactory(documentId, enabled), select });
}
